export default "__VITE_ASSET__l6IxAm9W__"